import { ca } from '@cian/analytics';

export function trackCreateFolder() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'add_collection',
    label: 'from_card',
    useLastProducts: true,
  });
}

export function trackSaveToFolder(offerId: number, position: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'add_to_collection',
    label: '',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
}

export function trackFolderNameClick(offerId: number, folderId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click_collection_name',
    label: folderId,
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}

interface IParams {
  offerId: number;
}

export function trackNotificationChangeFolder(params: IParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'Click',
    label: 'change_collection',
    products: [
      {
        id: params.offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}

export function trackNotificationSaveToFolder(params: IParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'Click',
    label: 'add_to_collection',
    products: [
      {
        id: params.offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
}
